module.exports = __webpack_public_path__ + "img/img5.cd04aafd.svg";